import { _ } from "../../../core/polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";
import keyFigureValueFormatter from "../../../models/keyFigure/rendering/keyFigureValueFormatter.js";

/**
 * Displays a table for multiple KeyFigures with each KeyFigure as a column and each period as a row.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {keyFigureValuesWidget} keyFigureValuesWidget
 */
function keyFigureValuesWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.entries = [];
	my.selectedPeriod = null;

	that.setResult = function (result) {
		my.entries = my.sortKeyFigureEntries(result.getValuesByKeyFigure());
		that.update();
	};

	that.setSelectedPeriod = function (period) {
		my.selectedPeriod = period;
		that.update();
	};

	that.renderContentOn = function (html) {
		html.div(
			{ klass: "table-responsive" },
			html.table(
				{ klass: "table table-hover table-striped table-bordered" },
				my.renderTableHeadOn,
				my.renderTableBodyOn,
			),
		);
	};

	my.renderTableHeadOn = function (html) {
		html.thead(
			html.tr(
				html.th(_("Period")),
				my.entries.map((entry) =>
					html.th(entry[0].getComponent().getName()),
				),
			),
		);
	};

	my.renderTableBodyOn = function (html) {
		html.tbody(
			getPeriods().map((period, index) =>
				html.tr(
					{ klass: my.tableDataClassForEntry(period) },
					html.td(my.periodRenderer(period)),
					my.entries.map((entry) =>
						html.td(
							my.keyFigureValueRenderer(entry[index], period),
						),
					),
				),
			),
		);
	};

	my.tableDataClassForEntry = function (period) {
		my.selectedPeriod ||= period;

		if (period === my.selectedPeriod) {
			return "current-period";
		}
		return "";
	};

	my.periodRenderer = function (period) {
		return function (html) {
			return html.a(
				{
					href: my.linkTo("multiple-kpis", {
						period: period.toString(),
					}),
				},
				period.toSmartString(),
			);
		};
	};

	my.keyFigureValueRenderer = function (keyFigureEntry, period) {
		return function (html) {
			return html.a(
				{
					href: my.linkTo("single-kpi", {
						keyFigure: keyFigureEntry.getComponent().getId(),
						period: period.toString(),
					}),
				},
				keyFigureValueFormatter.format(keyFigureEntry) || "-",
			);
		};
	};

	my.sortKeyFigureEntries = function (entries) {
		return entries.map((series) =>
			series.sort((a, b) =>
				a.getPeriod().getStart() > b.getPeriod().getStart() ? -1 : 1,
			),
		);
	};

	function getPeriods() {
		if (my.entries.length === 0) {
			return [];
		}
		return my.entries[0].map((entry) => entry.getPeriod());
	}

	return that;
}

export default keyFigureValuesWidget;
